import styled from "styled-components";
import { rgba } from "polished";

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px ${(props) => rgba(props.theme.colors.black, 0.06)};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
`;

export const TodayButton = styled.button`
  height: 36px;
  padding: 0 18px;
  border: 1px solid ${(props) => props.theme.colors.gray[200]};
  border-radius: 10px;
  background: #fff;
  color: ${(props) => props.theme.colors.gray[800]};
  font-size: 14px;
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    border-color: ${(props) => props.theme.colors.scale[400]};
    color: ${(props) => props.theme.colors.scale[600]};
  }
  &:active {
    transform: scale(0.97);
  }
`;

export const StepButton = styled.button`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: none;
  color: ${(props) => props.theme.colors.gray[700]};
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    background: ${(props) => rgba(props.theme.colors.scale[300], 0.25)};
    color: ${(props) => props.theme.colors.scale[600]};
  }
  &:active {
    transform: scale(0.94);
  }
`;

export const CurrentDate = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.gray[800]};
  white-space: nowrap;

  svg {
    color: ${(props) => props.theme.colors.scale[500]};
    flex-shrink: 0;
  }

  /* em monitor pequeno a data por extenso nao cabe ao lado dos controles */
  @media (max-width: 900px) {
    font-size: 16px;
    white-space: normal;
  }
`;

export const Week = styled.div`
  /* mostra duas semanas e deixa o espaco disponivel ser preenchido por dias,
     em vez de esticar sete deles pela tela inteira. Em tela estreita os dias
     da segunda semana saem de cena, ficando so a semana do dia escolhido. */
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 4px;

  @media (max-width: 1500px) {
    grid-template-columns: repeat(11, minmax(0, 1fr));
    > *:nth-child(n + 12) {
      display: none;
    }
  }

  @media (max-width: 1150px) {
    grid-template-columns: repeat(7, minmax(0, 1fr));
    > *:nth-child(n + 8) {
      display: none;
    }
  }
`;

export const Day = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 6px 4px;
  border: none;
  border-radius: 10px;
  background: ${(props) =>
    props.$selected ? props.theme.colors.scale[500] : "transparent"};
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    background: ${(props) =>
    props.$selected
      ? props.theme.colors.scale[500]
      : rgba(props.theme.colors.scale[300], 0.25)};
  }
  &:active {
    transform: scale(0.97);
  }

  strong {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: ${(props) =>
    props.$selected
      ? "#fff"
      : props.$today
        ? props.theme.colors.scale[600]
        : props.theme.colors.gray[600]};
  }

  span {
    font-size: 17px;
    font-weight: 600;
    color: ${(props) =>
    props.$selected
      ? "#fff"
      : props.$today
        ? props.theme.colors.scale[600]
        : props.theme.colors.gray[800]};
  }

  @media (max-width: 1100px) {
    strong {
      font-size: 9px;
    }
  }
`;
